import { useEffect, useState } from "react";
import { Button } from "@amber/ui";
import type { HomeResponse } from "@amber/application/contracts";
import { DeliveryPanel } from "./DeliveryPanel";
import { FRAME_TEXT } from "./format";
import { PlatformsPanel } from "./PlatformsPanel";
import { StatusPanel } from "./StatusPanel";
import { SustainabilityPanel } from "./SustainabilityPanel";

function TeamClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => {
      setNow(new Date());
    }, 1000);
    return () => {
      window.clearInterval(timer);
    };
  }, []);
  return (
    <span className="font-mono text-2xl">
      {now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
    </span>
  );
}

export function TeamScreen({ data, onExit }: { data: HomeResponse; onExit: () => void }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Team screen"
      className="fixed inset-0 z-sheet overflow-auto bg-surface p-6 text-lg"
    >
      <div className="mb-4 flex items-center gap-4">
        <h2 className="m-0 text-2xl font-semibold">Amber · Team screen</h2>
        <span className="text-muted">Read-only · refreshes every minute · {FRAME_TEXT[data.frame]}</span>
        <span className="ml-auto" />
        <TeamClock />
        <Button size="sm" onClick={onExit} autoFocus>
          Exit
        </Button>
      </div>
      <div className="space-y-4">
        <StatusPanel data={data} team />
        <div className="grid grid-cols-[minmax(0,1.65fr)_minmax(0,1fr)] gap-4">
          <DeliveryPanel data={data} team onFunnel={() => undefined} />
          <SustainabilityPanel data={data} team />
        </div>
        <PlatformsPanel data={data} team />
      </div>
    </div>
  );
}
